import React from "react";
import logo from './feelaxo-logo.svg';
import logoRound from './feelaxo-logo-mark-round-dark.svg';

interface LogoSvgProp {
  alt?: string;
  title?: string;
}

const LogoSvg: React.FC<LogoSvgProp> = ({ alt, title }) => {
  return (
    <div className="logo">
      <img
        className="w-40"
        src={logo}
        alt={alt || 'Feelaxo - Book Appointment for Salons, Spas, and Wellness Centers Online'}
        title={title || 'Feelaxo - Book Appointment for Salons, Spas, and Wellness Centers Online'}
      />
    </div>
  );
};

const LogoSvgRound: React.FC<LogoSvgProp> = ({ alt, title }) => {
  return (
    <div className="logo">
      <img
        className="w-40 h-10"
        src={logoRound}
        alt={alt || 'Feelaxo - Book Appointment for Salons, Spas, and Wellness Centers Online'}
        title={title || 'Feelaxo - Book Appointment for Salons, Spas, and Wellness Centers Online'}
      />
    </div>
  );
};

export { LogoSvg, LogoSvgRound };